import React, { useState, useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import EasySteps from '../components/EasySteps';
import JurisdictionSection from '../components/JurisdictionSection';
import CostCalculator from '../components/CostCalculator';
import EcosystemServices from '../components/EcosystemServices';
import ServiceCards from '../components/ServiceCards';
import ConsultationBanner from '../components/ConsultationBanner';
import GuideSection from '../components/GuideSection';
import StatsSection from '../components/StatsSection';
import BlogSection from '../components/BlogSection';
import ContactForm from '../components/ContactForm';
import QuickContactModal from '../components/QuickContactModal';

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="home-page">
      <HeroSection onOpenModal={() => setIsModalOpen(true)} />
      <EasySteps />
      <JurisdictionSection onOpenModal={() => setIsModalOpen(true)} />
      <CostCalculator />
      <EcosystemServices onOpenModal={() => setIsModalOpen(true)} />
      <ServiceCards />
      <ConsultationBanner onOpenModal={() => setIsModalOpen(true)} />
      <GuideSection />
      <StatsSection />
      <BlogSection />
      <ContactForm />
      <QuickContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default Home;